<template>
  <el-form
    :model="ruleForm2"
    :rules="rules2"
    ref="ruleForm2"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input
        type="text"
        v-model="ruleForm2.account"
        auto-complete="off"
        placeholder="请输入账号"
      ></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input
        type="password"
        v-model="ruleForm2.checkPass"
        auto-complete="off"
        placeholder="请输入密码"
      ></el-input>
    </el-form-item>
    <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
    <el-form-item style="width:100%;">
      <el-button
        type="primary"
        style="width:100%;"
        @click.native.prevent="handleSubmit2"
        :loading="logining"
      >登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { slogin } from "../api/api";
import { setCookie, getCookie, delCookie } from "../common/js/cookie.js";

export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        // account: 'admin',
        // checkPass: '123123'
        account: "",
        checkPass: ""
      },
      rules2: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" }
          //{ validator: validaePass }
        ],
        checkPass: [
          { required: true, message: "请输入密码", trigger: "blur" }
          //{ validator: validaePass2 }
        ]
      },
      checked: true
    };
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 ) {
        that.handleSubmit2();
        return false;
      }
    };
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2(ev) {
      var _this = this;
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass
          };
          slogin(loginParams).then(res => {
            this.logining = false;
            let { msg, code, data } = res;
            if (code !== 200) {
              this.$message({
                message: msg,
                type: "error"
              });
            } else {
             setCookie('login',data.token,60*60*24,"path=/;domain="+(location.hostname=='localhost'?'localhost':location.hostname.replace(/([a-zA-Z0-9\-])+\./,'.')));
             setCookie('user',encodeURIComponent(this.ruleForm2.account),60*60*24,"path=/;domain="+(location.hostname=='localhost'?'localhost':location.hostname.replace(/([a-zA-Z0-9\-])+\./,'.')));
             // setCookie("pwd", this.ruleForm2.checkPass, 60 * 60 * 24);
              this.$router.push({ path: "/" });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created(){
  	
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
@media only screen and (max-width:767px){
  .login-container{
    width: 200px;
    margin: 80px auto;
  }
}
</style>


// WEBPACK FOOTER //
// Login.vue?37abb2da